module.exports = __webpack_public_path__ + "img/feature_notification.d74fca20.png";